if ("variantDiscountedPrices" in window) {
  let newVariantDiscountedPrices = {};
  Object.keys(window.variantDiscountedPrices).forEach(function (key) {
    if (key.match(/\//)) {
      let keyArr = key.split("/");
      let variantId = keyArr[0];
      let minQty = parseInt(keyArr[1]);
      let newVariantDiscount = window.variantDiscountedPrices[key];
      newVariantDiscount.minQty = minQty;
      if (variantId in newVariantDiscountedPrices) {
        newVariantDiscountedPrices[variantId].push(newVariantDiscount);
      } else {
        newVariantDiscountedPrices[variantId] = [newVariantDiscount];
      }
    }
  });
  window.variantDiscountedPrices = newVariantDiscountedPrices;
  newVariantDiscountedPrices = undefined;
}

// noinspection JSUnusedGlobalSymbols
function u_cart(cart, options) {
  // noinspection JSUnresolvedVariable
  if (!cart.item_count || typeof variantDiscountedPrices == "undefined") {
    return cart;
  }

  // Attributes to update
  let itemPriceAttrToUpdate = "price";
  if (options && "itemPriceAttrToUpdate" in options) {
    itemPriceAttrToUpdate = options.itemPriceAttrToUpdate;
  }

  let cartTotal = 0;
  for (let i = 0; i < cart.items.length; i++) {
    // noinspection JSUnresolvedVariable
    if (cart.items[i].id in variantDiscountedPrices) {
      cart.items[i][itemPriceAttrToUpdate] = u_price(cart.items[i]);
      cart.items[i].line_price = cart.items[i].price * cart.items[i].quantity;
    }
    cartTotal += cart.items[i].line_price;
  }
  cart.total_price = cartTotal;
  return cart;
}

/**
 * Returns lowest applicable price for the item passed as an argument. The price is based on customer discounts
 * retrieved from Unleashed. If no discounts found, the standard item price will be returned.
 * @param item Shopify product variant or cart line item object
 * @param qty Number of items, to get price based on quantity break. If not specified and cart item object passed then
 * item.quantity attribute will be used. Default value: 1
 * @returns int
 */
function u_price(item, qty) {
  qty = qty ? qty : (item.quantity ? item.quantity : 1);
  if (!("variantDiscountedPrices" in window)) {
    throw new Error("variantDiscountedPrices variable not found");
  }
  if (typeof variantDiscountedPrices != "object") {
    throw new Error(`variantDiscountedPrices should be an object but type is ${typeof variantDiscountedPrices}`);
  }
  if (typeof item != "object") {
    throw new Error(`InvalidArgument: variant object expected but variable with a type of ${typeof item} passed`);
  }
  if (!item.hasOwnProperty("id")) {
    throw new Error("InvalidArgument: variant expected but `id` attribute is missing")
  }
  if (!(item.id in variantDiscountedPrices)) {
    return item.price;
  }
  variantDiscountedPrices[item.id].forEach(function(discount) {
    if (!("price_discounted" in discount)) {
      throw new Error("Discounted price not found in the `discount` object");
    }
    if (discount.minQty > 0 && qty < discount.minQty) {
      return;
    }
    if (discount.price_discounted < item.price) {
      item.price = discount.price_discounted;
    }
  });
  return item.price;
}

(function() {
  if ("cart_json" in window) {
    if ("u_cart" in window) {
      let cart = window.u_cart(window.cart_json);
      updateCartTemplate(cart);
      updateCartTotal();
    }
  }
})();
